<template>
  <div>
    <Modal v-model="displayModal" footer-hide transfer width="50%"
      :title="$t('contact.search_contact.modal_title')" :closable="false" @on-visible-change="handleModalVisibilityChange">
      <Input
        class="margin-bottom-20" search enter-button
        :placeholder="$t('contact.search_contact.search_placeholder')" v-model="hsSingleSearchInput"
        @on-search="handleHubspotSingleSearch" />
      <div>
        <Table
            :data="tableData"
            :loading="loading"
            :columns="columns"
            ref="contactsUnsynced"
            @on-selection-change="handleSelectionChange"
            >
        </Table>
      </div>
      <div class="text-align-right margin-top-10">
        <Button @click.native="handleCancelClick" class="margin-right-10">{{ $t('form.cancel') }}
        </Button>
        <Button type="primary" @click="handleSaveSelected">{{ $t('form.save') }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Vue from 'vue'
import 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
Vue.use(VXETable)

export default {
  name: 'HubspotContacts',
  props: {
    showModal: {
      type: Boolean,
      required: false
    }
  },
  data() {
    return {
      keyword: null,
      loading: false,
      columns: [
        {
          type: 'selection',
          width: 80,
          align: 'center'
        },
        {
          key: 'properties.firstname',
          title: 'Firstname',
          render: (h, params) => {
            return h('Span', params.row.properties.firstname)
          }
        },
        {
          key: 'lastname',
          title: 'Lastname',
          render: (h, params) => {
            return h('Span', params.row.properties.lastname)
          }
        },
        {
          key: 'email',
          title: 'Email',
          render: (h, params) => {
            return h('Span', params.row.properties.email)
          }
        }
      ],
      tableData: [],
      selectedContacts: [],
      displayModal: false,
      hsSingleSearchInput: ''
    }
  },
  watch: {
    showModal: function(newVal) {
      this.displayModal = newVal
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    ...mapActions([
      'loadHubspotContacts',
      'syncHsContactsToPangu',
      'searchHubspot'
    ]),
    init() {
      this.loadHubspotContacts().then(resp => {
        this.tableData = Object.values(resp)
      }).finally(() => {
        this.loading = false
      })
    },
    handleCancelClick () {
      this.displayModal = false
      this.$emit('reset-display-prop', false)
    },
    handleSaveSelected () {
      this.spinLoading = true
      this.syncHsContactsToPangu(this.selectedContacts)
        .then((resp) => {
          this.$Message.success("Hubspot contacts successfully synced")
        }).finally(() => {
          this.$emit('on-save', true)
          this.$emit('reset-display-prop', false)
          this.init()
        })
    },
    handleSelectionChange (selected) {
      this.selectedContacts = selected
    },
    handleHubspotSingleSearch (input) {
      this.loading = true
      if (!input) {
        this.init()
      } else {
        this.searchHubspot({ name: input }).then((resp) => {
          this.tableData = resp
        }).finally(() => {
          this.loading = false
        })
      }
    },
    handleModalVisibilityChange (visible) {
      if (!visible) {
        this.$emit('reset-display-prop', false)
      }
    }
  }
}
</script>
